import { getBackendUrl } from './config';

function forceDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function downloadResource(url, filename) {
  const backendBaseUrl = getBackendUrl()?.replace(/\/$/, '');
  const resolvedUrl =
    typeof url === 'string' && url.startsWith('/') && backendBaseUrl
      ? `${backendBaseUrl}${url}`
      : url;

  if (!filename) filename = String(resolvedUrl).split('\\').pop().split('/').pop();
  const tokenRaw = localStorage.getItem('token');
  const token =
    tokenRaw && tokenRaw.startsWith('"')
      ? (() => {
          try {
            return JSON.parse(tokenRaw);
          } catch {
            return tokenRaw;
          }
        })()
      : tokenRaw;

  fetch(resolvedUrl, {
    headers: new Headers({
      Origin: window.location.origin,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }),
    mode: 'cors',
    credentials: 'include',
  })
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(() => {});
}

const insertNineDigitBrazilianPhoneNumber = (number) => {
  if (number.length === 12) {
    return number.slice(0, 4) + '9' + number.slice(4);
  }
  return number;
};

/**
 * Helpers para detectar tipo de mídia.
 * Suporta mediaCategory (image|audio|video|application) e mediaType MIME (image/jpeg, audio/ogg, etc).
 */
export const isMediaImage = (msg) =>
  msg?.mediaCategory === 'image' ||
  msg?.mediaType === 'image' ||
  (typeof msg?.mediaType === 'string' && msg.mediaType.toLowerCase().startsWith('image/'));

export const isMediaAudio = (msg) =>
  msg?.mediaCategory === 'audio' ||
  msg?.mediaType === 'audio' ||
  msg?.mediaType === 'ptt' ||
  (typeof msg?.mediaType === 'string' && msg.mediaType.toLowerCase().startsWith('audio/'));

export const isMediaVideo = (msg) =>
  msg?.mediaCategory === 'video' ||
  msg?.mediaType === 'video' ||
  (typeof msg?.mediaType === 'string' && msg.mediaType.toLowerCase().startsWith('video/'));

export { downloadResource, insertNineDigitBrazilianPhoneNumber };
